import polyglotI18nProvider from 'ra-i18n-polyglot';
import frenchMessages from 'ra-language-french';
import type { I18nProvider } from 'react-admin';

/**
 * Traductions de l'interface.
 *
 * Le produit est en francais (CLAUDE.md), donc le backoffice l'est aussi : une
 * seule langue, sans selecteur. `ra-language-french` couvre le vocabulaire de
 * React Admin ; les surcharges ci-dessous corrigent les endroits ou le libelle
 * generique serait faux dans ce contexte.
 *
 * Le cas le plus important est la suppression. React Admin propose partout
 * « Supprimer » ; ici, **rien ne se supprime** — la tracabilite des lots
 * l'interdit (ADR 0011) et aucune route `DELETE` n'existe. Laisser le libelle
 * d'origine annoncerait une operation impossible.
 */
const messages = {
  ...frenchMessages,
  ra: {
    ...frenchMessages.ra,
    action: {
      ...frenchMessages.ra.action,
      delete: 'Archiver',
      bulk_actions: '%{smart_count} sélectionné(s)',
    },
    page: {
      ...frenchMessages.ra.page,
      dashboard: 'Tableau de bord',
      empty: 'Aucune donnée',
      invite: 'Souhaitez-vous en créer une ?',
    },
    message: {
      ...frenchMessages.ra.message,
      // Le message par defaut parle de suppression definitive, ce qui n'existe
      // pas ici.
      delete_content: 'Confirmez-vous l’archivage de cet élément ? L’opération est réversible.',
      not_found:
        'Page introuvable. Vérifiez l’URL, ou revenez au tableau de bord.',
      error:
        'Une erreur est survenue côté client. Si elle persiste, rechargez la page.',
    },
    navigation: {
      ...frenchMessages.ra.navigation,
      // Les collections paginees par le serveur ne rendent aucun total : le
      // libelle « 1-25 sur 132 » de React Admin n'a alors rien a afficher.
      page_range_info: '%{offsetBegin}-%{offsetEnd}',
      no_results: 'Aucun résultat',
    },
  },
  resources: {
    babies: { name: 'Profil bébé |||| Profils bébé' },
  },
};

/**
 * `allowMissing: false` est deliberé : un libelle manquant doit se voir en
 * developpement plutot que d'afficher une cle brute a l'utilisateur.
 */
export const i18nProvider: I18nProvider = polyglotI18nProvider(() => messages, 'fr', [
  { locale: 'fr', name: 'Français' },
]);
